import { render, staticRenderFns } from "./EventsBiddingList.vue?vue&type=template&id=a0602eca&scoped=true"
import script from "./EventsBiddingList.vue?vue&type=script&lang=js"
export * from "./EventsBiddingList.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingList.vue?vue&type=style&index=0&id=a0602eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0602eca",
  null
  
)

export default component.exports